import $axios from "@/api";

const groupUrl = "surat_tagihan"

const state = () => ({
    datas:{
        list : [],
        detail :[],
        suratTagihan : {},
    }
})

const mutations = {
    ASSIGN_DATA(state,payload){
        state.datas[payload.target] = payload.data
    },
}

const actions = {
    async listSuratTagihan({ commit }, filter) {
        try{
            const response =  await $axios.get(`${groupUrl}`,{params:filter})
            commit('ASSIGN_DATA',{target: 'list', data:response.data.data})
            return response.data
        }catch(error){
            console.log(error)
        }
    },
    async showSuratTagihan({ commit }, id) {
        try{
            const response =  await $axios.get(`${groupUrl}/${id}`)
            commit('ASSIGN_DATA',{target: 'suratTagihan', data:response.data.data})
        }catch(error){
            console.log(error)
        }
    },
    async detailGenerateSuratTagihan({ commit }, filter) {
        try{
            const response =  await $axios.get(`${groupUrl}/detail`,{params:filter})
            commit('ASSIGN_DATA',{target: 'detail', data:response.data.data})
        }catch(error){
            console.log(error)
        }
    },
    async generateSuratTagihan({ commit, state }, payload) {
        try{
            const response =  await $axios.post(`${groupUrl}`,payload)
            commit('ASSIGN_DATA',{target: 'detail', data:[]})
        }catch(error){
            console.log(error)
        }
    },
}


export default {    
    namespaced: true,
    state,
    actions,
    mutations
}
